import BaseServiceHttp from '../baseService'
class Logs extends BaseServiceHttp {
  constructor(id) {
    const resource = 'logs'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Logs(id)
